var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "creation-option-container" },
      [
        _c(
          "div",
          { staticClass: "icon-label-container" },
          [
            _c("v-icon", { staticClass: "creation-option-icon" }, [
              _vm._v("more_horiz")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "creation-option-label" }, [
              _vm._v(_vm._s(_vm.$t("NumberOf")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("v-slider", {
          staticStyle: { margin: "0 10px 0 20px" },
          attrs: {
            "thumb-label": "always",
            "thumb-size": 27,
            color: "var(--primary-highlight)",
            "thumb-color": "var(--primary-highlight)",
            "track-color": "#DDDDDD"
          },
          on: {
            input: function($event) {
              return _vm.updateNumber($event)
            },
            start: function($event) {
              return _vm.$emit("toggle-drag", true)
            },
            end: function($event) {
              return _vm.$emit("toggle-drag", false)
            }
          },
          model: {
            value: _vm.count,
            callback: function($$v) {
              _vm.count = $$v
            },
            expression: "count"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "creation-option-container" }, [
      _c(
        "div",
        { staticClass: "icon-label-container" },
        [
          _c(
            "v-icon",
            {
              staticClass: "creation-option-icon",
              staticStyle: { transform: "rotate(90deg)" }
            },
            [_vm._v("expand")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "creation-option-label" }, [
            _vm._v(_vm._s(_vm.$t("DistanceBetween")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.distanceBetweenTPs,
            expression: "distanceBetweenTPs"
          }
        ],
        staticClass: "distance-between-tps-input-field",
        class: { "too-many-points": _vm.tooManyPointsDrawn },
        attrs: { id: "distanceBetweenTPs", type: "number", min: 1 },
        domProps: { value: _vm.distanceBetweenTPs },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.distanceBetweenTPs = $event.target.value
            },
            function($event) {
              return _vm.updateDistance($event)
            }
          ]
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62efcd8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62efcd8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/BulkTP/BulkTPCreationOptions.vue
// module id = null
// module chunks = 